import styled from 'styled-components';
import { Box } from '../../../../layout/Box';

export const Wrapper = styled(Box)
    .withConfig({ displayName: 'ContentPromotionPostsChoosing' })
    .attrs({
        width: '100%',
        background: 'var(--background-primary)',
    })``;
